<div class="modal-header">
  <h4 class="modal-title">
    <ng-container *ngIf="inputAddOn !== null">
      <ng-container *ngIf="isGroupMembership">
        Edit Per-Customer Add-On
      </ng-container>
      <ng-container *ngIf="!isGroupMembership">
        Edit Membership Add-On
      </ng-container>
    </ng-container>
    <ng-container *ngIf="inputAddOn === null">
      <ng-container *ngIf="isGroupMembership">
        Add Per-Customer Add-On
      </ng-container>
      <ng-container *ngIf="!isGroupMembership">
        Add Membership Add-On
      </ng-container>
    </ng-container>
  </h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="row">
    <div class="form-group col-6">
      <label for="addOnNameInput">Name</label>
      <input id="addOnNameInput" type="text" name="add_on_name"
             required="required"
             class="form-control"
             [(ngModel)]="addOn.name">
      <div class="form-text text-danger">{{ errors.name }}</div>
    </div>
    <div class="form-group col-6">
      <label for="addOnFeeInput">Fee Amount</label>
      <input id="addOnFeeInput" type="number" name="add_on_fee"
             required="required" min="0" step="0.01"
             class="form-control"
             [(ngModel)]="feeNumber">
      <div class="form-text text-danger">{{ errors.feeNumber }}</div>
    </div>
  </div>

  <div class="form-group">
    <div class="form-check">
      <input id="addOnIsVisibleInput" type="checkbox" value="" name="add_on_is_visible"
             class="form-check-input"
             [(ngModel)]="addOn.is_visible">
      <label class="form-check-label" for="addOnIsVisibleInput">
        Allow customers to select this add-on when purchasing a membership.
      </label>
    </div>
    <small class="form-text text-muted">
      Regardless of this setting, a customer's membership add-ons may always be edited by staff members.
    </small>
    <div class="form-text text-danger">{{ errors.is_visible }}</div>
  </div>

  <div class="form-group">
    <label for="addOnIconInitialsInput">Icon Initials</label>
    <input id="addOnIconInitialsInput" type="text" class="form-control" name="add_on_icon_initials"
           required maxlength="2"
           [(ngModel)]="addOn.icon_initials">
    <small class="form-text">2 characters max</small>
    <div class="form-text text-danger">{{ errors.icon_initials }}</div>
  </div>

  <div class="form-group">
    <label for="addOnIconColorHexSelect">Icon Color</label>
    <app-color-picker [id]="'addOnIconColorHexSelect'"
                      [(content)]="addOn.icon_color_hex"
                      [cpPosition]="'top-right'"></app-color-picker>
    <div class="form-text text-danger">{{ errors.icon_color_hex }}</div>
  </div>

  <div class="form-group">
    <label for="add_on_tax_rate_id">Tax Rate</label>
    <select id="add_on_tax_rate_id" class="custom-select" name="add_on_tax_rate_id"
            [(ngModel)]="addOn.tax_rate_id">
      <option [ngValue]="undefined" class="text-muted">Use membership tax rate</option>
      <option *ngIf="taxRateRemoved(addOn.tax_rate_id)"
              [ngValue]="addOn.tax_rate_id">
        (Removed Tax Rate)
      </option>
      <option *ngFor="let taxRate of taxRateList" [ngValue]="taxRate.id">
        {{ taxRate.name }}
      </option>
    </select>
    <div class="form-text text-danger">{{ errors.tax_rate_id }}</div>
  </div>

  <div class="form-group" *ngIf="locationService.getLocations() && (locationService.getLocations().length > 1)">
    <div class="indented-subsection">
      <div class="form-check mb-2">
        <input type="checkbox"
               id="addOnHasPerLocationTaxRates"
               name="addOnHasPerLocationTaxRates"
               class="form-check-input"
               [(ngModel)]="hasPerLocationTaxRates">
        <label class="form-check-label" for="addOnHasPerLocationTaxRates">
          Configure tax rate by location
        </label>
      </div>

      <ng-container *ngIf="hasPerLocationTaxRates">
        <p class="text-muted mb-2" *ngIf="Object.keys(addOn.tax_rate_per_location).length === 0">
          No locations selected
        </p>

        <div class="mb-2" *ngFor="let locId of Object.keys(addOn.tax_rate_per_location)">
          <div class="row">
            <div class="col-5 pr-0">
              <input type="text"
                     class="form-control form-control-sm disabled"
                     disabled
                     value="{{ getLocNameById(locId) }}">
            </div>
            <div class="col-5 pr-0">
              <select class="custom-select custom-select-sm"
                      name="add_on_tax_rate{{ locId }}"
                      [(ngModel)]="addOn.tax_rate_per_location[locId]">
                <option *ngIf="taxRateRemoved(addOn.tax_rate_per_location[locId])"
                        [ngValue]="addOn.tax_rate_per_location[locId]">
                  (Removed Tax Rate)
                </option>
                <option *ngFor="let taxRate of taxRateList"
                        [ngValue]="taxRate.id">
                  {{ taxRate.name }} - {{ taxRate.rate_percent }}%
                </option>
              </select>
            </div>
            <div class="col-2">
              <button class="btn btn-sm btn-danger"
                      (click)="deleteProp(addOn.tax_rate_per_location, locId);">
                X
              </button>
            </div>
          </div>
        </div>

        <button class="btn btn-sm btn-outline-primary d-block"
                type="button"
                [disabled]="taxRateList.length === 0"
                [class.disabled]="taxRateList.length === 0"
                (click)="addTaxRateLocation()">
          Add Location
        </button>

        <div class="form-text text-danger">{{ errors.tax_rate_per_location }}</div>
        <small class="form-text text-muted">
          A per-location tax rate will replace the default tax rate configured above.
        </small>
      </ng-container>
    </div>
  </div>

  <ng-container *ngIf="usesSpecificAllthenticateProducts">
    <div class="form-group">
      <div class="form-check">
        <input id="addOnSendsAllthenticateInviteInput" type="checkbox" value=""
               name="add_on_sends_allthenticate_invite"
               class="form-check-input"
               [(ngModel)]="addOn.sends_allthenticate_invite">
        <label class="form-check-label" for="addOnSendsAllthenticateInviteInput">
          Send an Allthenticate invite to customers with this add-on.
        </label>
      </div>
      <div class="form-text text-danger">{{ errors.sends_allthenticate_invite }}</div>
    </div>

    <div class="form-group">
      <div class="form-check">
        <input id="addOnOverridesLimitedEntryInput" type="checkbox" value=""
               name="add_on_overrides_limited_entry"
               class="form-check-input"
               [(ngModel)]="addOn.overrides_limited_entry">
        <label class="form-check-label" for="addOnOverridesLimitedEntryInput">
          Allow customers with this add-on to enter at any time.
        </label>
      </div>
      <small class="form-text text-muted">
        Customers with this add-on may enter on any day, at any time, even when
        the membership is limited to particular entry days and times.
      </small>
      <div class="form-text text-danger">{{ errors.overrides_limited_entry }}</div>
    </div>
  </ng-container>

  <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
    {{ errorMessage }}
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary"
          (click)="activeModal.close()">
    Cancel
  </button>
  <button class="btn btn-primary"
          (click)="handleSubmit()">
    Submit
  </button>
</div>
